import type { ColumnDef } from '@tanstack/react-table';

import { type GetTermsRecordsQuery } from 'data/__generated__';
import { textColumn, dateColumn } from 'components/DataTable';

export type TermsRecordRow = GetTermsRecordsQuery['termsRecords'][number];

export const termsRecordsColumns: ColumnDef<TermsRecordRow, unknown>[] = [
    textColumn<TermsRecordRow, never>({
        accessorKey: '_id',
        header: 'Id',
        defaultVisible: true,
    }),
    dateColumn<TermsRecordRow, never>({
        accessorKey: 'createdAt',
        header: 'Date de cr\u00e9ation',
        defaultVisible: true,
    }),
    textColumn<TermsRecordRow, never>({
        accessorKey: 'termsOfUseUrl',
        header: 'Lien des CGV',
        defaultVisible: true,
        cell: ({ row }) => (
            <a
                href={row.original.termsOfUseUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:underline"
            >
                {row.original.termsOfUseUrl}
            </a>
        ),
    }),
];
